import { MyStudiesProduct } from 'components/Flux/Personalized/MyStudies/product';
import useResendUploadStudy from 'components/Flux/Upload/MyStudies/useResendUploadStudy';
import useUploadRowActions from 'components/Flux/Upload/StudyRow/useStudyRowActions';
import { uploadMyStudiesApiPort } from 'services/api/uploadMyStudies';
import useUploadDownload from 'utils/hooks/flux/upload/useUploadDownload';
import { MyStudy } from 'types/Flux/Personalized/myStudies';

/** Nome do zip na linha (o backend já manda o basename; `split` é defesa). `null` = sem detalhe. */
export function uploadRowDetail(study: MyStudy): string | null {
  const { file } = study;
  if (typeof file !== 'string' || file.trim() === '') return null;
  const parts = file.split('/');
  return parts[parts.length - 1] || null;
}

/** Flux Upload: mesmas rotas de ação do legado, lista do slice `uploadMyStudies`, sem painel. */
export const UPLOAD_PRODUCT: MyStudiesProduct = {
  key: 'upload',
  api: uploadMyStudiesApiPort,
  storage: {
    filtersPrefix: 'flux-upload-meus-estudos-filtros-v1',
    noticePrefix: 'flux-upload-meus-estudos-aviso-casos-ampere-v1',
  },
  expandable: false,
  rowDetail: uploadRowDetail,
  emptyCompany: {
    title: 'Sua empresa ainda não tem estudos de upload',
    text: 'Envie um ZIP com o estudo pronto. Ele entra na fila e você baixa os resultados quando terminar.',
    cta: 'Novo estudo upload',
    newStudyPath: '/flux/upload/new',
  },
  useDownload: useUploadDownload,
  useRowActions: useUploadRowActions,
  useResend: useResendUploadStudy,
};
